module.exports = __webpack_public_path__ + "img/zk3.32c47d71.jpg";